import { Injectable } from "@angular/core";
import { Http } from "@angular/http";
import { AuthenticationService } from "app/pages/login/authentication.service";
import { ConfigService } from "../config/config.service";


import {throwError as observableThrowError,  Observable } from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import { Response, Headers } from '@angular/http';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';

import { SelectItem } from 'primeng/api';
import { environment } from "environments/environment";

@Injectable()
export class IframeService {

    constructor(
        private http: HttpClient,       
        private configService: ConfigService,
        private auth: AuthenticationService 
    ){}


    verifyPermission(userName, endpoint){
        return this.http.get(environment.urlCoreApi+endpoint+'/'+userName, {headers: this.getHttpHeaders()}).pipe(catchError(this.handleError));
    }

    getHttpHeaders() : HttpHeaders {
        let headers = new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': this.auth.getToken()
        });

        return headers;
    }

    private handleError(error: HttpErrorResponse) {
        return observableThrowError(error.message);
    }

}